import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const SCHEDULE_TZ = "Europe/Kyiv";

/** Ключ AsyncStorage / localStorage */
export const BIRTHDAY_REMINDER_DISMISS_STORAGE_KEY = "scheduleBdayReminderDismissed";

/** Після «далекого» закриття знову показуємо, коли лишилось не більше стільки днів. */
export const BIRTHDAY_REMINDER_SHOW_AGAIN_WITHIN_DAYS = 3;

/** @returns {{ far: Record<string, string>, near: Record<string, string> }} */
export function emptyDismissState() {
    return { far: {}, near: {} };
}

/**
 * Нормалізує збережений JSON: нова форма { far, near } або стара плоска мапа → лише far.
 * @returns {{ far: Record<string, string>, near: Record<string, string> }}
 */
export function parseDismissState(raw) {
    if (raw == null || raw === "") return emptyDismissState();
    try {
        const o = JSON.parse(raw);
        if (!o || typeof o !== "object" || Array.isArray(o)) return emptyDismissState();
        if (
            o.far &&
            typeof o.far === "object" &&
            !Array.isArray(o.far) &&
            o.near &&
            typeof o.near === "object" &&
            !Array.isArray(o.near)
        ) {
            return { far: { ...o.far }, near: { ...o.near } };
        }
        return { far: { ...o }, near: {} };
    } catch {
        /* ignore */
    }
    return emptyDismissState();
}

/**
 * Стабільний ключ циклу ДН для збереження (з API або з daysUntil у Києві).
 * @param { { nextBirthdayDate?: string, daysUntil: number } } it
 * @returns { string | null }
 */
export function reminderBirthdayKey(it) {
    const nb = it.nextBirthdayDate;
    if (typeof nb === "string" && /^\d{4}-\d{2}-\d{2}$/.test(nb.trim())) return nb.trim();
    const du = it.daysUntil;
    if (typeof du !== "number" || !Number.isInteger(du) || du < 0) return null;
    return dayjs().tz(SCHEDULE_TZ).startOf("day").add(du, "day").format("YYYY-MM-DD");
}

/**
 * @param { { userId: string, daysUntil: number, nextBirthdayDate?: string } } it
 * @param {{ far: Record<string, string>, near: Record<string, string> }} state
 */
export function isBirthdayReminderItemVisible(it, state) {
    const uid = String(it.userId);
    const nb = reminderBirthdayKey(it);
    if (!nb) return true;

    if (state.near[uid] === nb) return false;

    if (it.daysUntil <= BIRTHDAY_REMINDER_SHOW_AGAIN_WITHIN_DAYS) return true;

    if (state.far[uid] === nb) return false;

    return true;
}
